import Api from "../../Api";

export const getCountries = async()=>{
    try {
        let res = await Api.get("/countries");
        return (res?.data || [])
    }
    catch (e) {
        console.log(e);
        return ([])
    }
}